import { Component, ElementRef, ViewChild } from '@angular/core';
import { TagsComponent } from '../../../shared/components/tags/tags.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NavMapComponent } from '../../../shared/components/nav-map/nav-map.component';
import { take } from 'rxjs/internal/operators/take';
import { AuthenticationService } from '../../../shared/services/authentication.service';
import {
	ClientClipControllerService,
	ClientSentimentControllerService,
	ClipTagRequest,
	ExportRequest,
	ManagementClipFilterRequest,
	GenerateClipReportRequest,
	ManagementClipControllerService,
	// ManagementClipItemResponse,
	ManagementClipResponse,
	ClientAnalyticsControllerService,
	ClientClipsByDateAnalyticsResponse,
	ClientClipsByTagAnalyticsResponse,
	ClientClipsByMediumAnalyticsResponse,
	ClientClipsByAuthorAnalyticsResponse,
} from 'api-clipping';
import { SharedService } from '../../../shared/services/shared.service';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { TagsDropAssignService } from '../../../shared/services/tags-drop-assign.service';
import { Constants } from '../../../shared/interfaces/constants';
import { ActivatedRoute } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
	ManagementContractNoticeResponse,
	ClientContractNoticeControllerService,
	ClientContractAnnouncementControllerService,
	ManagementContractNoticeAndAnnouncementResponse,
	SalesFilterRequest,
	ManagementSaleControllerService,
	ManagementSaleResponse,
	ClientSaleControllerService,
	ManagementBankruptcyResponse,
	ClientBankruptcyControllerService,
	BankruptciesFilterRequest,
	ManagementContractNoticeAndAnnouncementFilterRequest,
} from 'api-contract-notices';
import { TranscriptionResponse } from 'api-transcription';
import { UtilsService } from '../../../shared/services/utils.service';
import { ClipsFiltersComponent } from '../../../admin/components/data-administration/clipping/clips-filters/clips-filters.component';
import { ContractNoticesFiltersComponent } from '../../../admin/components/data-administration/contract-notices/contract-notices-filters/contract-notices-filters.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { SalesFiltersComponent } from '../../../admin/components/data-administration/sales/sales-filters/sales-filters.component';
import { CommonModule } from '@angular/common';
import { BankruptciesFiltersComponent } from '../../../admin/components/data-administration/bankruptcies/bankruptcies-filters/bankruptcies-filters.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ClipsDetailedViewComponent } from '../../../admin/components/data-administration/clipping/clips-detailed-view/clips-detailed-view.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonToggleChange, MatButtonToggleModule } from '@angular/material/button-toggle';
import { environment } from '../../../../environments/environment';
import { Subject, Subscription, debounceTime, distinctUntilChanged } from 'rxjs';
import { ClientControllerService, ClientTagControllerService, ManagementClientResponse } from 'api-client';
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { AnalyticsFiltersComponent } from '../../../admin/components/data-administration/analytics/analytics-filters/analytics-filters.component';
import { TimeSeriesChartComponent } from '../../../admin/components/data-administration/analytics/analytics-charts/time-series-chart/time-series-chart.component';
import { RotatedLabelsColumnChartComponent } from '../../../admin/components/data-administration/analytics/analytics-charts/rotated-labels-column-chart/rotated-labels-column-chart.component';
import { ProgressChartComponent } from '../../../admin/components/data-administration/analytics/analytics-charts/progress-chart/progress-chart.component';
import { SimpleTreemapChartComponent } from '../../../admin/components/data-administration/analytics/analytics-charts/simple-treemap-chart/simple-treemap-chart.component';
import { WordCloudChartComponent } from '../../../admin/components/data-administration/analytics/analytics-charts/word-cloud-chart/word-cloud-chart.component';
import { TranscriptionsFiltersComponent } from './transcriptions/transcriptions-filters/transcriptions-filters.component';
import { TranscriptionsToolbarComponent } from './transcriptions/transcriptions-toolbar/transcriptions-toolbar.component';
import { TranscriptionsFormComponent } from '../../../shared/components/transcriptions/transcriptions-form/transcriptions-form.component';
import { ClientTranscriptionControllerService, ClientTranscriptionFilterRequest, UploadControllerService, ResourceRequest, DeleteTranscriptionsRequest, ExportTranscriptionRequest } from 'api-transcription';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { ClientDataCardComponent } from './client-data-card/client-data-card.component';
import { ClientClippingStatsComponent } from './client-clipping-stats/client-clipping-stats.component';
import { AnalyticsPanelComponent } from '../analytics/analytics-panel.component';
interface ItemForEdit {
	clip: ManagementClipResponse | undefined;
	transcription: any | undefined;
	contract_notice: ManagementContractNoticeResponse | undefined;
}

interface ManagementClipResponseWithRelated extends ManagementClipResponse {
	related?: any;
	expanded?: boolean;
	checked?: boolean;
}

interface ManagementContractNoticeAndAnnouncementWithRelated extends ManagementContractNoticeAndAnnouncementResponse {
	related?: any[];
}

interface TranscriptionResponseWithSelection extends TranscriptionResponse {
	checked?: boolean;
}

@Component({
	selector: 'app-data-preview',
	standalone: true,
	imports: [
		CommonModule,
		FormsModule,
		TagsComponent,
		DragDropModule,
		MatCardModule,
		ClipsFiltersComponent,
		NavMapComponent,
		MatTabsModule,
		TranslateModule,
		InfiniteScrollDirective,
		ContractNoticesFiltersComponent,
		SalesFiltersComponent,
		BankruptciesFiltersComponent,
		MatButtonModule,
		MatTooltipModule,
		MatIconModule,
		MatExpansionModule,
		MatDividerModule,
		MatCheckboxModule,
		MatMenuModule,
		MatButtonToggleModule,
		AnalyticsFiltersComponent,
		TimeSeriesChartComponent,
		RotatedLabelsColumnChartComponent,
		ProgressChartComponent,
		SimpleTreemapChartComponent,
		WordCloudChartComponent,
		TranscriptionsFiltersComponent,
		TranscriptionsToolbarComponent,
		TranscriptionsFormComponent,
		ClientDataCardComponent,
		ClientClippingStatsComponent,
		AnalyticsPanelComponent,
	],
	templateUrl: './data-preview.component.html',
	styleUrl: './data-preview.component.scss',
})
export class DataPreviewComponent {
	resellerSettingsContext: any;
	externalAssets = environment.reseller.externalAssets;
	externalAssetsRoot = environment.reseller.externalAssetsRoot;
	mobileView = false;
	@ViewChild('listScrollAnchor', { static: false }) listScrollAnchor!: ElementRef;
	@ViewChild('inputFormAnchor', { static: false }) inputFormAnchor!: ElementRef;
	@ViewChild(ClipsFiltersComponent) clipsFiltersComponent!: ClipsFiltersComponent;
	@ViewChild(TranscriptionsFiltersComponent) transcriptionsFiltersComponent?: TranscriptionsFiltersComponent;
	showFilters = true;

	/**
	 * Open state of the right-hand filters panel. Default `true` = expanded.
	 * Static so the choice survives section switches and component re-creation
	 * but resets on a full page reload.
	 */
	private static filtersPanelOpenState = true;
	get filtersPanelOpen(): boolean {
		return DataPreviewComponent.filtersPanelOpenState;
	}
	set filtersPanelOpen(value: boolean) {
		DataPreviewComponent.filtersPanelOpenState = value;
	}

	toggleFiltersPanel(): void {
		this.filtersPanelOpen = !this.filtersPanelOpen;
	}

	/** Types that render the categories/tags section in the client sidebar. */
	get hasCategoriesSection(): boolean {
		return this.dataAdministrationType !== 'SALES' && this.dataAdministrationType !== 'BANKRUPTCIES' && this.dataAdministrationType !== 'ANALYTICS';
	}

	/**
	 * CLIPPING-600 Phase 3: Contract Notices/Announcements, Sales, Bankruptcies (Step 1) and
	 * Transcriptions (Step 2) - the SETTE restyle hook for content-header/header-action-btn and
	 * app-tags, same pattern as the CLIPPING-only ".content-header--clipping"/".tags--clipping"
	 * hooks from Phase 2.
	 */
	get isRestTab(): boolean {
		return (
			this.dataAdministrationType === 'CONTRACT_NOTICES' ||
			this.dataAdministrationType === 'CONTRACT_ANNOUNCEMENTS' ||
			this.dataAdministrationType === 'SALES' ||
			this.dataAdministrationType === 'BANKRUPTCIES' ||
			this.dataAdministrationType === 'TRANSCRIPTIONS'
		);
	}

	dataAdministrationType: 'CLIPPING' | 'CONTRACT_NOTICES' | 'CONTRACT_ANNOUNCEMENTS' | 'SALES' | 'BANKRUPTCIES' | 'ANALYTICS' | 'TRANSCRIPTIONS' = 'CLIPPING';

	public itemsList: ManagementClipResponse[] | ManagementContractNoticeResponse[] | ManagementContractNoticeAndAnnouncementWithRelated[] | TranscriptionResponseWithSelection[] = [];
	public itemForEdit!: ItemForEdit;
	// Seconds to start the video at, from the transcription deep-link's &t= param. Null otherwise.
	public transcriptionDeepLinkSeconds: number | null = null;

	public selectedItems: any[] = [];
	public highlightItemId = '';

	readonly ITEMS_PER_PAGE = 30;
	throttle = 50;
	scrollDistance = 2;
	appendModeActive = false;
	pagination = {
		active: 'LIST', // 'LIST' | 'FILTER' | 'FILTER_WITHOUT_TAGS' | 'FILTER_BY_MEDIUM',
		currentPage: 0,
		totalPages: 0,
		totalElements: 0,
	};

	public filtersStore: ManagementClipFilterRequest | ManagementContractNoticeAndAnnouncementFilterRequest | SalesFilterRequest | ClientTranscriptionFilterRequest | undefined | boolean;
	reloadFilters = false;

	// scroll lock beacuse is firing multiple times on end
	// (known issue https://stackoverflow.com/questions/34822077/scroll-function-firing-multiple-times-instead-of-once)
	scrollLock = {
		locked: false,
		debounceTime: 500,
	};
	scrollToTop = {
		initialYPos: 0,
		active: false,
	};
	apiLoading = false;

	clipsSort: 'newest' | 'oldest' | 'mostReach' | 'leastReach' | 'mostInfluence' | 'leastInfluence' = 'newest';
	listSort: 'newest' | 'oldest' = 'newest';
	transcriptionSearchText = '';
	private transcriptionSearch$ = new Subject<string>();

	private readonly clipsSortMap: Record<typeof this.clipsSort, { sortBy: string; sortDir: 'ASC' | 'DESC'; labelKey: string }> = {
		newest: { sortBy: 'publicationDate', sortDir: 'DESC', labelKey: 'ASSORTED.NEWEST_FIRST' },
		oldest: { sortBy: 'publicationDate', sortDir: 'ASC', labelKey: 'ASSORTED.OLDEST_FIRST' },
		mostReach: { sortBy: 'visibilityIndex', sortDir: 'DESC', labelKey: 'ASSORTED.MOST_REACH' },
		leastReach: { sortBy: 'visibilityIndex', sortDir: 'ASC', labelKey: 'ASSORTED.LEAST_REACH' },
		mostInfluence: { sortBy: 'sentimentScore', sortDir: 'DESC', labelKey: 'ASSORTED.MOST_INFLUENCE' },
		leastInfluence: { sortBy: 'sentimentScore', sortDir: 'ASC', labelKey: 'ASSORTED.LEAST_INFLUENCE' },
	};

	get clipsSortLabelKey(): string {
		return this.clipsSortMap[this.clipsSort].labelKey;
	}

	public externalFilters: any;

	private contractNoticeFilterSubscription$!: Subscription;

	client!: ManagementClientResponse;
	availableCountries: any[] = [];

	clipsByDate: ClientClipsByDateAnalyticsResponse[] = [];
	clipsByTag: ClientClipsByTagAnalyticsResponse[] = [];
	clipsByMedium: ClientClipsByMediumAnalyticsResponse[] = [];
	clipsBySentiment: { sentimentType: string; clipsCount: number }[] = [];
	clipsByAuthor: ClientClipsByAuthorAnalyticsResponse[] = [];
	commonWords: { word: string; count: number }[] = [];

	constructor(
		private route: ActivatedRoute,
		public utils: UtilsService,
		private apiClippingClips: ClientClipControllerService,
		public sharedService: SharedService,
		private translate: TranslateService,
		public tagsDropAssign: TagsDropAssignService,
		private apiClientContractNotice: ClientContractNoticeControllerService,
		private apiClientContractAnnouncement: ClientContractAnnouncementControllerService,
		private apiClientSales: ClientSaleControllerService,
		private apiClientBankruptcies: ClientBankruptcyControllerService,
		private apiClient: ClientControllerService,
		private apiClientTags: ClientTagControllerService,
		private apiClientSentiment: ClientSentimentControllerService,
		private apiClientAnalytics: ClientAnalyticsControllerService,
		private apiClientTranscriptions: ClientTranscriptionControllerService,
		private apiTranscriptionUpload: UploadControllerService,
		private http: HttpClient,
		private responsive: BreakpointObserver,
		private matDialog: MatDialog,
		private authentication: AuthenticationService
	) {
		this.sharedService.resellerSettingsContext.pipe(takeUntilDestroyed()).subscribe({
			next: response => {
				this.resellerSettingsContext = response;
				this.resellerSettingsContext.reseller = environment.reseller;
				this.resellerSettingsContext.reseller.logo = `${environment.reseller.assets}/images/${response.navBar.logo}`;
			},
		});

		this.responsive
			.observe([Breakpoints.XSmall, Breakpoints.Small])
			.pipe(takeUntilDestroyed())
			.subscribe(result => {
				this.mobileView = false;

				if (result.matches) {
					this.mobileView = true;
				}
			});

		// Debounced auto-search for the transcriptions header field.
		this.transcriptionSearch$
			.pipe(debounceTime(400), distinctUntilChanged(), takeUntilDestroyed())
			.subscribe(() => this.triggerTranscriptionSearch());

		this.route.queryParams.subscribe(params => {
			setTimeout(() => { // timeout to ensure that the filters are loaded
				const dataType = Constants.ADMINISTRATION_DATA_TYPES.get(this.route.snapshot.params['type']);
				if (dataType === 'TRANSCRIPTIONS') {
					// Deep-link: ?id=<transcriptionId> opens that transcription in read-only preview mode.
					// Optional &t=<seconds> (from the keyword-notification email) starts the video there.
					const transcriptionId = params['id'] ? params['id'] : null;
					this.transcriptionDeepLinkSeconds = params['t'] ? parseInt(params['t'], 10) : null;
					if (transcriptionId) {
						this.openTranscriptionPreviewById(transcriptionId);
					}
				} else {
					this.externalFilters = {
						createdAtFrom: params['createdAtFrom'] ? new Date(parseInt(params['createdAtFrom'], 10)) : null,
						createdAtTo: params['createdAtTo'] ? new Date(parseInt(params['createdAtTo'], 10)) : null,
						types: params['types'] ? params['types'].split(',') : [],
						contractAuthorityId: params['contractAuthorityId'] ? params['contractAuthorityId'] : null,
						searchText: params['searchText'] ? params['searchText'] : null,
					};
				}

				const clip = params['clip'] ? params['clip'] : null;
				if (clip) {
					this.apiClippingClips
						.getClientClipById(clip)
						.pipe(take(1))
						.subscribe({
							next: response => {
								const dialogRef = this.matDialog.open(ClipsDetailedViewComponent, {
									width: '90%',
									data: {
										item: response,
									},
								});
							},
							error: err => {
								this.sharedService.showNotification.next({
									message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
									type: 'ERROR',
								});
								this.apiLoading = false;
							},
						});
				}
			}, 500);
		});

		this.route.params.pipe(takeUntilDestroyed()).subscribe(params => {
			this.dataAdministrationType = Constants.ADMINISTRATION_DATA_TYPES.get(params['type']) || 'CLIPPING';

			this.itemsList = [];
			this.itemForEdit = {
				clip: undefined,
				transcription: undefined,
				contract_notice: undefined,
			};
			this.selectedItems = [];
			this.filtersStore = false;

			if (this.dataAdministrationType === 'TRANSCRIPTIONS' || this.dataAdministrationType === 'SALES' || this.dataAdministrationType === 'BANKRUPTCIES' || this.dataAdministrationType === 'ANALYTICS') {
				this.actionByTypeSplitter({
					action: 'LOAD',
				});
			}
		});

		this.loadClientProfile();
	}

	/** Virtual scroll methods */
	onScrollDown(event: any) {
		this.appendModeActive = true;
		if (!this.scrollLock.locked) {
			this.scrollLock.locked = true;
			if (this.filtersStore) {
				this.actionByTypeSplitter({
					action: 'FILTER',
					data: 'list',
					filters: this.filtersStore,
				});
			}

			setTimeout(() => {
				this.scrollLock.locked = false;
			}, this.scrollLock.debounceTime);
		}
	}

	private paginationState(active: 'LIST' | 'FILTER' | 'FILTER_BY_MEDIUM', startIndex?: number) {
		this.pagination.active = active;
		if (startIndex === 0) {
			if (this.listScrollAnchor) {
				this.listScrollAnchor.nativeElement.scrollIntoView({ behavior: 'instant', block: 'start' });
			}

			this.pagination.currentPage = 0;
			this.pagination.totalPages = 1;
			this.appendModeActive = false;
		} else {
			startIndex = ++this.pagination.currentPage;
		}

		return this.pagination.currentPage <= this.pagination.totalPages - 1;
	}

	private setPaginationState(totalElements: number, itemsPerPage?: number) {
		this.pagination.totalPages = totalElements ? Math.ceil(totalElements / this.ITEMS_PER_PAGE) : 0;
		if (itemsPerPage !== undefined) {
			this.pagination.currentPage = itemsPerPage / this.ITEMS_PER_PAGE;
			setTimeout(() => {
				this.scrollElementIntoView(this.highlightItemId);
			}, 500);
		}
	}

	private scrollElementIntoView(id: string) {
		let el = document.getElementById(id);
		if (el) {
			this.highlightItemId = id;
			el.scrollIntoView({ behavior: 'instant', block: 'center' });
		}
		setTimeout(() => {
			// how long will the highlight last
			this.highlightItemId = '';
		}, 2000);
	}

	scrollPosition(event: any) {
		if (!this.scrollToTop.initialYPos && this.listScrollAnchor) {
			this.scrollToTop.initialYPos = this.listScrollAnchor.nativeElement.getBoundingClientRect().top;
		}

		this.scrollToTop.active = this.scrollToTop.initialYPos > 2.5 * this.listScrollAnchor.nativeElement.getBoundingClientRect().top;
	}
	/** (END)Virtual scroll methods */

	actionByTypeSplitter(event: any) {
		switch (this.dataAdministrationType) {
			case 'CLIPPING': {
				this.actionRequestedClipping(event);
				break;
			}
			case 'TRANSCRIPTIONS': {
				this.actionRequestedTranscription(event);
				break;
			}
			case 'CONTRACT_NOTICES':
			case 'CONTRACT_ANNOUNCEMENTS': {
				this.actionRequestedContractNotices(event);
				break;
			}
			case 'SALES': {
				this.actionRequestedSale(event);
				break;
			}
			case 'BANKRUPTCIES': {
				this.actionRequestedBankruptcy(event);
				break;
			}
			case 'ANALYTICS': {
				this.actionRequestedAnalytics(event);
				break;
			}
		}
	}

	getDisplayFieldByDataType(fieldName: string, item?: ManagementContractNoticeAndAnnouncementResponse | ManagementSaleResponse | ManagementBankruptcyResponse | TranscriptionResponse) {
		switch (this.dataAdministrationType) {
			case 'CLIPPING': {
				const itemTypeSafe: ManagementClipResponse = item as ManagementClipResponse;

				if (fieldName === 'publishedDate') {
					return this.utils.formatDate(itemTypeSafe.publicationDate);
				} else if (fieldName === 'medium') {
					return this.utils.getParameterByLanguageScript(itemTypeSafe.medium, 'name');
				} else if (fieldName === 'title') {
					return this.utils.getParameterByLanguageScript(itemTypeSafe, fieldName, true);
				} else if (fieldName === 'brief') {
					// 700-char cap to match the admin brief limit (clips-form.component.ts)
					return this.utils.truncateText(this.utils.getParameterByLanguageScript(itemTypeSafe, fieldName, true), 700);
				} else if (fieldName === 'mediaUrl') {
					if (itemTypeSafe.medium?.type === 'TV' || itemTypeSafe.medium?.type === 'RADIO') {
						return itemTypeSafe.medium?.mediaUrl ? itemTypeSafe.medium?.mediaUrl : 'fallback_image';
					}
					return itemTypeSafe.mediaUrl ? itemTypeSafe.mediaUrl : itemTypeSafe.medium?.mediaUrl ? itemTypeSafe.medium?.mediaUrl : 'fallback_image';
				} else if (fieldName === 'tags') {
					return itemTypeSafe.tags;
				}
				break;
			}
			case 'CONTRACT_NOTICES':
			case 'CONTRACT_ANNOUNCEMENTS': {
				const itemTypeSafe: ManagementContractNoticeAndAnnouncementResponse = item as ManagementContractNoticeAndAnnouncementResponse;
				if (fieldName === 'title') {
					if (itemTypeSafe.noticeType) {
						return this.utils.getParameterByLanguageScript(itemTypeSafe, 'contractSubject', true);
					} else if (itemTypeSafe.announcementType) {
						return this.utils.getParameterByLanguageScript(itemTypeSafe.contractNotice, 'contractSubject', true);
					}
				} else if (fieldName === 'medium') {
					let mediums: string[] = [];
					if (itemTypeSafe.noticeType) {
						if (itemTypeSafe.mediums) {
							itemTypeSafe.mediums.forEach((medium: any) => {
								mediums.push(this.utils.getParameterByLanguageScript(medium, 'name'));
							});
						}
					} else if (itemTypeSafe.announcementType) {
						if (itemTypeSafe.contractNotice && itemTypeSafe.contractNotice.mediums) {
							itemTypeSafe.contractNotice.mediums.forEach((medium: any) => {
								mediums.push(this.utils.getParameterByLanguageScript(medium, 'name'));
							});
						}
					}
					return mediums;
				} else if (fieldName === 'country') {
					if (itemTypeSafe.noticeType) {
						return itemTypeSafe.country ? itemTypeSafe.country.toLowerCase() : '';
					} else {
						return itemTypeSafe.contractNotice?.country ? itemTypeSafe.contractNotice?.country.toLowerCase() : '';
					}
				} else if (fieldName === 'publishedDate') {
					return this.utils.formatDate(itemTypeSafe.publishedDate);
				} else if (fieldName === 'deliveryDate') {
					if (itemTypeSafe.noticeType && itemTypeSafe.deliveryDate) {
						return this.utils.formatDate(itemTypeSafe.deliveryDate);
					}
					// } else if (itemTypeSafe.announcementType && itemTypeSafe.contractNotice && itemTypeSafe.contractNotice.deliveryDate) {
					// 	return this.utils.formatDate(itemTypeSafe.contractNotice.deliveryDate);
					// }
					return null;
				} else if (fieldName === 'content') {
					if (itemTypeSafe.noticeType) {
						return this.utils.getParameterByLanguageScript(itemTypeSafe.contractAuthority, 'name', true);
					} else {
						return this.utils.getParameterByLanguageScript(itemTypeSafe.contractNotice?.contractAuthority, 'name', true);
					}
				} else if (fieldName === 'type') {
					if (itemTypeSafe.noticeType) {
						return this.translate.instant('CONTRACT_NOTICES.' + itemTypeSafe.noticeType);
					} else if (itemTypeSafe.announcementType) {
						return this.translate.instant('CONTRACT_ANNOUNCEMENTS.' + itemTypeSafe.announcementType);
					}
				} else if (fieldName === 'estimatedPurchaseValue') {
					if (itemTypeSafe.noticeType) {
						return itemTypeSafe.estimatedPurchaseValue ? `${this.utils.formatCurrency(itemTypeSafe.estimatedPurchaseValue.toString())} ${itemTypeSafe.currency}` : '';
					} else if (itemTypeSafe.announcementType) {
						return '';
						// return itemTypeSafe.contractNotice?.estimatedPurchaseValue
						// 	? `${this.utils.formatCurrency(itemTypeSafe.contractNotice.estimatedPurchaseValue.toString())} ${itemTypeSafe.contractNotice.currency}`
						// 	: '';
					}
				} else if (fieldName === 'divisiblePurchase') {
					if (itemTypeSafe.noticeType) {
						return itemTypeSafe.divisiblePurchase;
					} else if (itemTypeSafe.announcementType) {
						return itemTypeSafe.contractNotice?.divisiblePurchase;
					}
				} else if (fieldName === 'contractors') {
					if (itemTypeSafe.announcementType && itemTypeSafe.contractors) {
						return itemTypeSafe.contractors.map(c => this.utils.getParameterByLanguageScript(c, 'name', true)).join(' | ');
					}
					return '';
				} else if (fieldName === 'agreementValue') {
					if (itemTypeSafe.announcementType) {
						return itemTypeSafe.agreementValue ? `${this.utils.formatCurrency(itemTypeSafe.agreementValue.toString())} ${itemTypeSafe.currency}` : '';
					}
					return '';
				} else if (fieldName === 'eauction') {
					return itemTypeSafe.eauction;
				}
				break;
			}
			case 'SALES': {
				const itemTypeSafe: ManagementSaleResponse = item as ManagementSaleResponse;
				if (fieldName === 'link') {
					return 'generate pdf';
				} else if (fieldName === 'publishedDate') {
					return this.utils.formatDate(itemTypeSafe.publicationDate);
				} else if (fieldName === 'saleDate') {
					return this.utils.formatDate(itemTypeSafe.saleDate);
				} else if (fieldName === 'debtor' && itemTypeSafe.debtors) {
					return itemTypeSafe.debtors.map(c => this.utils.getParameterByLanguageScript(c, 'name', true)).join(' | ');
				} else if (fieldName === 'trustee') {
					const trustees = itemTypeSafe.trustees?.map(t => this.utils.getParameterByLanguageScript(t, 'name', true));
					return trustees?.join(', ');
				} else if (fieldName === 'placeOfSale') {
					const placeOfSale = itemTypeSafe.placesOfSale;
					return placeOfSale?.join(', ');
				} else if (fieldName === 'location') {
					const locations = itemTypeSafe.locations;
					return locations?.join(', ');
				} else if (fieldName === 'saleType') {
					return itemTypeSafe.type;
				}
				break;
			}
			case 'BANKRUPTCIES': {
				const itemTypeSafe: ManagementBankruptcyResponse = item as ManagementBankruptcyResponse;
				if (fieldName === 'publishedDate') {
					return this.utils.formatDate(itemTypeSafe.publicationDate);
				} else if (fieldName === 'company' && itemTypeSafe.company) {
					return this.utils.getParameterByLanguageScript(itemTypeSafe.company, 'name', true);
				} else if (fieldName === 'phase') {
					return itemTypeSafe.phase;
				}
				break;
			}
			case 'TRANSCRIPTIONS': {
				const itemTypeSafe: any = item as any;
				if (fieldName === 'fileName') {
					return itemTypeSafe.fileName;
				} else if (fieldName === 'content') {
					if (itemTypeSafe.content && itemTypeSafe.content.length > 0) {
						const allText = itemTypeSafe.content.map((c: any) => c.text || '').join(' ').trim();
						return this.utils.truncateText(allText, 700);
					}
					return '';
				} else if (fieldName === 'createdAt') {
					return this.utils.formatDate(itemTypeSafe.createdAt);
				} else if (fieldName === 'lang') {
					return itemTypeSafe.lang.toLowerCase();
				} else if (fieldName === 'url') {
					return itemTypeSafe.url || itemTypeSafe.fileUrl || '';
				}
				break;
			}
		}
		return;
	}

	//** General methods */
	onMostValuableClipOpen(clip: any) {
		if (!clip) return;
		if (clip.url && (clip.medium?.type === 'WEB' || clip.medium?.type === 'SOCIAL')) {
			this.utils.openLinkInNewTab(clip.url);
		} else {
			this.matDialog.open(ClipsDetailedViewComponent, {
				width: '90%',
				data: { item: clip },
			});
		}
	}

	private loadClientProfile() {
		this.apiClient
			.getClientDetails()
			.pipe(take(1))
			.subscribe(response => {
				this.availableCountries = [];
				const currentDate = new Date();

				const loginData = this.authentication.loginData.getValue();
				const userEmail = loginData?.identifier?.toLowerCase();

				if (!userEmail) {
					this.client = response;
					return;
				}

				const activeSubscriptions = response.subscriptions?.filter(sub => {
					if (sub.validTo && new Date(sub.validTo) < currentDate) return false;

					const emailTo = sub.emailTo?.map(e => e.toLowerCase()) || [];
					const emailCc = sub.emailCc?.map(e => e.toLowerCase()) || [];
					const emailBcc = sub.emailBcc?.map(e => e.toLowerCase()) || [];
					const isEmailAuthorized = emailTo.includes(userEmail) || emailCc.includes(userEmail) || emailBcc.includes(userEmail);

					return isEmailAuthorized;
				}) || [];

				Constants.COUNTRIES.forEach(c => {
					let availability: any = [];

					if (c.countryCode === 'MK') {
						availability = activeSubscriptions
							.filter(sub => sub.type && !sub.type.includes('ALBANIA') && !sub.type.includes('KOSOVO'))
							.map(sub => sub.type?.replaceAll('CONTRACT_NOTICES_ANNOUNCEMENTS', 'CONTRACT_ANNOUNCEMENTS'));
					} else if (c.countryCode === 'AL') {
						availability = activeSubscriptions
							.filter(sub => sub.type && sub.type.includes('ALBANIA'))
							.map(sub => sub.type?.replaceAll('CONTRACT_NOTICES_ANNOUNCEMENTS', 'CONTRACT_ANNOUNCEMENTS'));
					} else if (c.countryCode === 'XK') {
						availability = activeSubscriptions
							.filter(sub => sub.type && sub.type.includes('KOSOVO'))
							.map(sub => sub.type?.replaceAll('CONTRACT_NOTICES_ANNOUNCEMENTS', 'CONTRACT_ANNOUNCEMENTS'));
					}
					
					this.availableCountries.push({
						...c,
						availability,
					});
				});
				this.client = response;

				if (this.client.id) {
					this.loadBrandTagIds(this.client.id);
				}
			});
	}

	private loadBrandTagIds(clientId: string) {
		this.apiClientTags
			.getClientTagsDetails(clientId)
			.pipe(take(1))
			.subscribe({
				next: tags => {
					const companyIds = new Set<string>();
					const competitorIds = new Set<string>();
					tags.forEach(t => {
						if (t.tagType === 'CLIPPING' && t.brandKind === 'COMPANY' && t.tagId) {
							companyIds.add(t.tagId);
						}
						if (t.tagType === 'CLIPPING' && t.brandKind === 'COMPETITOR' && t.tagId) {
							competitorIds.add(t.tagId);
						}
					});
					this.sharedService.companyTagIds.next(companyIds);
					this.sharedService.competitorTagIds.next(competitorIds);
				},
			});
	}

	//** Clipping methods */
	actionRequestedClipping(event: any) {
		// this.appendModeActive = false;
		switch (event.action) {
			// case 'LOAD': {
			// 	if (event.data === 'list') {
			// 		this.getClips(event.id);
			// 	} else if (event.data === 'listItem') {
			// 		this.getClip(event.id);
			// 	} else if (event.data === 'filterCheck') {
			// 		this.highlightItemId = event.id;
			// 		this.filterClipsStateCheck();
			// 	}
			// 	break;
			// }
			case 'FILTER': {
				this.filterClips(event.filters, event.id);
				break;
			}
			// case 'FILTER_BY_MEDIUM': {
			// 	//this.filterByMedium(event.filters, event.id);
			// 	this.filterClips(event.filters, event.id);

			// 	break;
			// }
			case 'UPDATE_SELECTED': {
				this.selectedItems = event.selected;
				break;
			}
			case 'TAGS_SELECTION_CHANGE': {
				this.sharedService.requestActionInComponent.next({
					componentName: 'ClipsFiltersComponent',
					action: 'FILTER_TRIGGER',
					data: {
						dataAdministrationType: this.dataAdministrationType,
					},
				});
				break;
			}
			case 'DETAILS': {
				if (event.item.medium.type === 'WEB' || event.item.medium.type === 'SOCIAL') {
					this.utils.openLinkInNewTab(event.item.url);
				} else {
					const dialogRef = this.matDialog.open(ClipsDetailedViewComponent, {
						width: '90%',
						data: {
							item: event.item,
						},
					});
				}
				break;
			}
			case 'PDF_SINGLE': {
				this.generatePdfReport(this.utils.suppressType(event.item), 'SINGLE');
				break;
			}
			case 'PDF_GROUP': {
				this.generatePdfReport(this.utils.suppressType(event.item), 'GROUP');
				break;
			}
			case 'SCREENSHOT': {
				this.openScreenshotLink(this.utils.suppressType(event.item));
				break;
			}
			case 'SENTIMENT': {
				this.createUpdateSentimentRating(event.sentimentType, this.utils.suppressType(event.item));
				break;
			}
			case 'RELATED_CLIPS': {
				this.getRelatedClips(this.utils.suppressType(event.item));
				break;
			}
		}
	}

	// private getClips(startIndex?: number, itemsPerPage?: number) {
	// 	this.filtersStore = undefined;

	// 	if (this.paginationState('LIST', startIndex)) {
	// 		this.apiLoading = true;
	// 		this.apiClippingClips
	// 			.getClientClipsPageable(this.pagination.currentPage, itemsPerPage || this.ITEMS_PER_PAGE)
	// 			.pipe(take(1))
	// 			.subscribe({
	// 				next: response => {
	// 					this.itemsList = response.content || [];
	// 					this.setPaginationState(response.totalElements || 0, itemsPerPage);
	// 					this.apiLoading = false;
	// 				},
	// 			});
	// 	}
	// }

	// private getClip(clipId: string) {
	// 	this.apiClippingClips
	// 		.getClientClipDetails(clipId)
	// 		.pipe(take(1))
	// 		.subscribe({
	// 			next: response => {
	// 				this.itemForEdit.clip = response;
	// 				this.inputFormAnchor.nativeElement.scrollIntoView({ behavior: 'instant', block: 'start' });
	// 				this.apiLoading = false;
	// 			},
	// 		});
	// }

	// private filterClipsStateCheck() {
	// 	this.appendModeActive = true;
	// 	if (this.filtersStore && (this.filtersStore as FilterRequest).mediumId) {
	// 		this.filterByMedium(this.filtersStore as FilterRequest, 0, this.pagination.currentPage * this.ITEMS_PER_PAGE);
	// 	} else if (this.filtersStore) {
	// 		this.filterClips(this.filtersStore as FilterRequest, 0, this.pagination.currentPage * this.ITEMS_PER_PAGE);
	// 	} else {
	// 		this.getClips(0, this.pagination.currentPage * this.ITEMS_PER_PAGE);
	// 	}
	// }

	onClipsSortChange(value: typeof this.clipsSort) {
		this.clipsSort = value;
		if (this.filtersStore && typeof this.filtersStore !== 'boolean') {
			this.filterClips(this.filtersStore as ManagementClipFilterRequest, 0);
		}
	}

	/**
	 * Header search for transcriptions. Keeps the (hidden) sidebar filter form in sync on every
	 * keystroke — so the sidebar's Show/Reset buttons and the date range all operate on the same
	 * request — and debounces the actual auto-search.
	 */
	onTranscriptionSearchChange(value: string) {
		this.transcriptionSearchText = value;
		this.transcriptionsFiltersComponent?.filtersFormGroup.controls['text'].setValue(value?.trim() || null, { emitEvent: false });
		this.transcriptionSearch$.next(value?.trim() || '');
	}

	/** Runs the transcriptions filter (shared form → same endpoint), used by debounce and Enter. */
	triggerTranscriptionSearch() {
		const filters = this.transcriptionsFiltersComponent;
		if (!filters) return;
		filters.filtersFormGroup.controls['text'].setValue(this.transcriptionSearchText?.trim() || null, { emitEvent: false });
		filters.filterListItems();
	}

	onListSortChange(value: 'newest' | 'oldest') {
		this.listSort = value;
		if (!this.filtersStore || typeof this.filtersStore === 'boolean') return;
		switch (this.dataAdministrationType) {
			case 'CONTRACT_NOTICES':
			case 'CONTRACT_ANNOUNCEMENTS':
				this.filterContractNotices(this.filtersStore as ManagementContractNoticeAndAnnouncementFilterRequest, 0);
				break;
			case 'SALES':
				this.filterSales(this.filtersStore as SalesFilterRequest, 0);
				break;
			case 'BANKRUPTCIES':
				this.filterBankruptcies(this.filtersStore as BankruptciesFilterRequest, 0);
				break;
			case 'TRANSCRIPTIONS':
				this.filterTranscriptions(this.filtersStore as ClientTranscriptionFilterRequest, 0);
				break;
		}
	}

	private filterClips(filters: ManagementClipFilterRequest, startIndex?: number, itemsPerPage?: number) {
		this.filtersStore = filters;
		if (this.paginationState('FILTER', startIndex)) {
			this.apiLoading = true;
			const { sortBy, sortDir } = this.clipsSortMap[this.clipsSort];
			//this.apiClippingClips.getClientFilteredClipsPageable(filters, this.pagination.currentPage, itemsPerPage || this.ITEMS_PER_PAGE)
			this.apiClippingClips
				.getClientClipsPageableFilter(filters, this.pagination.currentPage, itemsPerPage || this.ITEMS_PER_PAGE, sortBy, sortDir)
				.pipe(take(1))
				.subscribe({
					next: response => {
						if (this.appendModeActive) {
							(this.itemsList as ManagementClipResponse[]).push.apply(this.itemsList, response.content || []);
						} else {
							this.itemsList = response.content || [];
						}
						this.pagination.totalPages = response.totalPages || 0;
						this.pagination.totalElements = response.totalElements || 0;
						this.apiLoading = false;
					},
					error: err => {
						this.sharedService.showNotification.next({
							message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
							type: 'ERROR',
						});
						this.apiLoading = false;
					},
				});
		}
	}

	// private filterByMedium(filters: FilterRequest, startIndex?: number, itemsPerPage?: number) {
	// 	this.filtersStore = filters;

	// 	if (this.paginationState('FILTER_BY_MEDIUM', startIndex)) {
	// 		this.apiLoading = true;
	// 		this.apiClippingClips
	// 			.getClientFilteredClipsByMediumPageable(filters, this.pagination.currentPage, itemsPerPage || this.ITEMS_PER_PAGE)
	// 			.pipe(take(1))
	// 			.subscribe({
	// 				next: response => {
	// 					this.itemsList = response.content || [];
	// 					this.setPaginationState(response.totalElements || 0, itemsPerPage);
	// 					this.apiLoading = false;
	// 				},
	// 				error: err => {
	// 					this.sharedService.showNotification.next({
	// 						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
	// 						type: 'ERROR',
	// 					});
	// 					this.apiLoading = false;
	// 				},
	// 			});
	// 	}
	// }

	getRelatedClips(item: ManagementClipResponseWithRelated) {
		if (!item.related && item.groupId) {
			this.apiLoading = true;

			this.apiClippingClips
				.getClientClips(item.groupId)
				.pipe(take(1))
				.subscribe({
					next: response => {
						if (response.length) {
							item.related = new Map();

							Constants.CLIP_TYPES.forEach(ct => {
								item.related.set(ct.id, []);
							});

							let storedData;
							response.forEach(clip => {
								storedData = item.related.get(clip.medium?.type);
								storedData.push(clip);
								item.related.set(clip.medium?.type, storedData);
							});
						}
						this.apiLoading = false;
						item.expanded = response.length ? true : false;
					},
					error: () => {
						this.apiLoading = false;
					},
				});
		} else if (item.related) {
			item.expanded = !item.expanded;
		} else {
			item.expanded = false;
		}
	}

	getAuthors(item: ManagementClipResponse) {
		if (item?.authors?.length) {
			return item.authors.map((author: any) => this.utils.getParameterByLanguageScript(author, 'name')).join(', ');
		}
		return '';
	}

	openScreenshotLink(item: any) {
		if (item.screenshotUrl) {
			window.open(`${this.externalAssetsRoot}${item.screenshotUrl}`, '_blank');
		}
	}

	public generatePdfReport(item: ManagementClipResponse, type: 'SINGLE' | 'GROUP') {
		this.apiLoading = true;
		if (type === 'SINGLE') {
			this.apiClippingClips
				.generateClientPdfReportForAllClipsByIds({
					clientId: this.client.id,
					clipIds: [item.id],
					lang: this.utils.currentLanguage.toUpperCase() as GenerateClipReportRequest.LangEnum,
				})
				.pipe(take(1))
				.subscribe({
					next: (response: any) => {
						const content = new Blob([response as BlobPart], { type: 'application/pdf' });
						const fileURL = URL.createObjectURL(content);
						window.open(fileURL, '_blank');
						this.apiLoading = false;
					},
					error: err => {
						this.sharedService.showNotification.next({
							message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
							type: 'ERROR',
						});
						this.apiLoading = false;
					},
				});
		} else if (type === 'GROUP') {
			this.apiClippingClips
				.generateClientPdfReportForMainClipWithRelated({
					clientId: this.client.id,
					groupId: item.groupId,
					lang: this.utils.currentLanguage.toUpperCase() as GenerateClipReportRequest.LangEnum,
				})
				.pipe(take(1))
				.subscribe({
					next: (response: any) => {
						const content = new Blob([response as BlobPart], { type: 'application/pdf' });
						const fileURL = URL.createObjectURL(content);
						window.open(fileURL, '_blank');
						this.apiLoading = false;
					},
					error: err => {
						this.sharedService.showNotification.next({
							message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
							type: 'ERROR',
						});
						this.apiLoading = false;
					},
				});
		}
	}

	public exportClientClips() {
		const filtersData = this.clipsFiltersComponent.getFiltersFormData();

		const MS_IN_A_DAY = 1000 * 60 * 60 * 24;
		const ALLOWED_DAYS_LIMIT = 33;

		// The export range is picked in the dialog, defaulting to whatever the filter is set to.
		// getFiltersFormData() hands back dateTo already pushed a day forward (exclusive end), so
		// step it back to show the same date the filter displays.
		const defaultDateFrom = filtersData.dateFrom ? new Date(filtersData.dateFrom) : null;
		let defaultDateTo = null;
		if (filtersData.dateTo) {
			defaultDateTo = new Date(filtersData.dateTo);
			defaultDateTo.setDate(defaultDateTo.getDate() - 1);
		}

		const dialogRef = this.matDialog.open(ConfirmationDialogComponent, {
			width: '500px',
			panelClass: 'confirmation-dialog-panel--client',
			data: {
				mode: 'CREATE',
				type: 'custom-fields',
				skipFormValidation: true,
				message: this.translate.instant('CLIPS.XLS_REPORT_CONFIRMATION'),
				fields: [
					{
						type: 'date',
						key: 'dateFrom',
						label: 'CLIPS.PUBLISHED_DATE_FROM',
						required: true,
						inline: true,
						defaultValue: defaultDateFrom,
					},
					{
						type: 'date',
						key: 'dateTo',
						label: 'CLIPS.PUBLISHED_DATE_TO',
						required: true,
						inline: true,
						maxDaysFrom: 'dateFrom',
						maxDaysLimit: ALLOWED_DAYS_LIMIT,
						defaultValue: defaultDateTo,
					},
				],
			},
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result && result.data) {
				const dateFrom = new Date(result.data.dateFrom);
				const dateTo = new Date(result.data.dateTo);

				const diffInDays = Math.abs(dateTo.getTime() - dateFrom.getTime()) / MS_IN_A_DAY;

				if (diffInDays > ALLOWED_DAYS_LIMIT) {
					this.sharedService.showNotification.next({
						message: this.translate.instant('CLIPS.EXPORT_CLIPS_CONFIRMATION_MESSAGE', { ALLOWED_DAYS_LIMIT }),
						type: 'ERROR',
					});
					return;
				}

				const exportDateFrom = new Date(dateFrom);
				exportDateFrom.setHours(0, 0, 0);

				// The filter treats dateTo as an exclusive end, so match it here — otherwise clips
				// published on the chosen end date fall outside the export.
				const exportDateTo = new Date(dateTo);
				exportDateTo.setHours(0, 0, 0);
				exportDateTo.setDate(exportDateTo.getDate() + 1);

				const exportRequest: ExportRequest = {
					clientId: this.client.id,
					dateFrom: exportDateFrom,
					dateTo: exportDateTo,
				};

				this.apiLoading = true;
				this.apiClippingClips
					.exportClientClips(exportRequest)
					.pipe(take(1))
					.subscribe({
						next: (response: any) => {
							const content = new Blob([response as BlobPart], { type: 'application/vnd.ms-excel' });
							const fileURL = URL.createObjectURL(content);
							window.open(fileURL, '_blank');
							this.apiLoading = false;
						},
						error: err => {
							this.sharedService.showNotification.next({
								message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
								type: 'ERROR',
							});
							this.apiLoading = false;
						},
					});
			}
		});
	}

	public exportClientContractNotices() {
		const MS_IN_A_DAY = 1000 * 60 * 60 * 24;
		const ALLOWED_DAYS_LIMIT = 33;

		// Get all contract notice types (already includes CANCELLATION and MODIFICATION)
		const allNoticeTypes = Constants.CONTRACT_NOTICE_TYPES;

		const dialogRef = this.matDialog.open(ConfirmationDialogComponent, {
			width: '500px',
			panelClass: 'confirmation-dialog-panel--client',
			data: {
				mode: 'CREATE',
				type: 'custom-fields',
				skipFormValidation: true,
				message: this.translate.instant('CONTRACT_NOTICES.EXPORT_CONFIRMATION'),
				fields: [
					{
						type: 'selection',
						key: 'noticeType',
						label: 'CONTRACT_NOTICES.TYPE',
						required: true,
						standalone: true,
						data: allNoticeTypes.map(type => ({
							value: type,
							label: this.translate.instant('CONTRACT_NOTICES.' + type),
							default: type === 'CONTRACT_NOTICE'
						}))
					},
					{
						type: 'date',
						key: 'dateFrom',
						label: 'CLIPS.PUBLISHED_DATE_FROM',
						required: true,
						inline: true
					},
					{
						type: 'date',
						key: 'dateTo',
						label: 'CLIPS.PUBLISHED_DATE_TO',
						required: true,
						inline: true,
						maxDaysFrom: 'dateFrom',
						maxDaysLimit: 33
					}
				]
			},
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result && result.data) {
				const dateFrom = new Date(result.data.dateFrom);
				const dateTo = new Date(result.data.dateTo);

				const diffInDays = Math.abs(dateTo.getTime() - dateFrom.getTime()) / MS_IN_A_DAY;

				if (diffInDays > ALLOWED_DAYS_LIMIT) {
					this.sharedService.showNotification.next({
						message: this.translate.instant('CONTRACT_NOTICES.EXPORT_DATE_LIMIT_MESSAGE', { ALLOWED_DAYS_LIMIT }),
						type: 'ERROR',
					});
					return;
				}

				const tagIds = this.tagsDropAssign.manuallyselectedTags?.map(tag => tag.id) || [];

				const exportRequest: any = {
					clientId: this.client.id,
					type: result.data.noticeType,
					tagIds: tagIds.length > 0 ? tagIds : undefined,
					dateFrom: dateFrom,
					dateTo: dateTo,
				};

				this.apiLoading = true;
				this.apiClientContractNotice
					.exportClientContractNotices(exportRequest)
					.pipe(take(1))
					.subscribe({
						next: (response: any) => {
							const content = new Blob([response as BlobPart], { type: 'application/vnd.ms-excel' });
							const fileURL = URL.createObjectURL(content);
							window.open(fileURL, '_blank');
							this.apiLoading = false;
						},
						error: err => {
							this.sharedService.showNotification.next({
								message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
								type: 'ERROR',
							});
							this.apiLoading = false;
						},
					});
			}
		});
	}

	public exportClientContractAnnouncements() {
		const MS_IN_A_DAY = 1000 * 60 * 60 * 24;
		const ALLOWED_DAYS_LIMIT = 33;

		const dialogRef = this.matDialog.open(ConfirmationDialogComponent, {
			width: '500px',
			panelClass: 'confirmation-dialog-panel--client',
			data: {
				mode: 'CREATE',
				type: 'custom-fields',
				skipFormValidation: true,
				message: this.translate.instant('CONTRACT_ANNOUNCEMENTS.EXPORT_CONFIRMATION'),
				fields: [
					{
						type: 'date',
						key: 'dateFrom',
						label: 'CLIPS.PUBLISHED_DATE_FROM',
						required: true,
						inline: true
					},
					{
						type: 'date',
						key: 'dateTo',
						label: 'CLIPS.PUBLISHED_DATE_TO',
						required: true,
						inline: true,
						maxDaysFrom: 'dateFrom',
						maxDaysLimit: 33
					}
				]
			},
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result && result.data) {
				const dateFrom = new Date(result.data.dateFrom);
				const dateTo = new Date(result.data.dateTo);

				const diffInDays = Math.abs(dateTo.getTime() - dateFrom.getTime()) / MS_IN_A_DAY;

				if (diffInDays > ALLOWED_DAYS_LIMIT) {
					this.sharedService.showNotification.next({
						message: this.translate.instant('CONTRACT_ANNOUNCEMENTS.EXPORT_DATE_LIMIT_MESSAGE', { ALLOWED_DAYS_LIMIT }),
						type: 'ERROR',
					});
					return;
				}

				const tagIds = this.tagsDropAssign.manuallyselectedTags?.map(tag => tag.id) || [];

				const exportRequest: any = {
					clientId: this.client.id,
					type: 'CONTRACT_AWARD',
					tagIds: tagIds.length > 0 ? tagIds : undefined,
					dateFrom: dateFrom,
					dateTo: dateTo,
				};

				this.apiLoading = true;
				this.apiClientContractAnnouncement
					.exportClientContractAnnouncements(exportRequest)
					.pipe(take(1))
					.subscribe({
						next: (response: any) => {
							const content = new Blob([response as BlobPart], { type: 'application/vnd.ms-excel' });
							const fileURL = URL.createObjectURL(content);
							window.open(fileURL, '_blank');
							this.apiLoading = false;
						},
						error: err => {
							this.sharedService.showNotification.next({
								message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
								type: 'ERROR',
							});
							this.apiLoading = false;
						},
					});
			}
		});
	}

	public exportClientSales() {
		const MS_IN_A_DAY = 1000 * 60 * 60 * 24;
		const ALLOWED_DAYS_LIMIT = 33;

		const dialogRef = this.matDialog.open(ConfirmationDialogComponent, {
			width: '500px',
			panelClass: 'confirmation-dialog-panel--client',
			data: {
				mode: 'CREATE',
				type: 'custom-fields',
				skipFormValidation: true,
				message: this.translate.instant('SALES.EXPORT_CONFIRMATION'),
				fields: [
					{
						type: 'date',
						key: 'dateFrom',
						label: 'CLIPS.PUBLICATION_DATE_FROM',
						required: true,
						inline: true
					},
					{
						type: 'date',
						key: 'dateTo',
						label: 'CLIPS.PUBLICATION_DATE_TO',
						required: true,
						inline: true,
						maxDaysFrom: 'dateFrom',
						maxDaysLimit: 33
					}
				]
			},
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result && result.data) {
				const dateFrom = new Date(result.data.dateFrom);
				const dateTo = new Date(result.data.dateTo);

				const diffInDays = Math.abs(dateTo.getTime() - dateFrom.getTime()) / MS_IN_A_DAY;

				if (diffInDays > ALLOWED_DAYS_LIMIT) {
					this.sharedService.showNotification.next({
						message: this.translate.instant('SALES.EXPORT_DATE_LIMIT_MESSAGE', { ALLOWED_DAYS_LIMIT }),
						type: 'ERROR',
					});
					return;
				}

				const exportRequest: any = {
					clientId: this.client.id,
					dateFrom: dateFrom,
					dateTo: dateTo,
				};

				this.apiLoading = true;
				this.apiClientSales
					.exportClientSales(exportRequest)
					.pipe(take(1))
					.subscribe({
						next: (response: any) => {
							const content = new Blob([response as BlobPart], { type: 'application/vnd.ms-excel' });
							const fileURL = URL.createObjectURL(content);
							window.open(fileURL, '_blank');
							this.apiLoading = false;
						},
						error: err => {
							this.sharedService.showNotification.next({
								message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
								type: 'ERROR',
							});
							this.apiLoading = false;
						},
					});
			}
		});
	}

	public exportClientBankruptcies() {
		const MS_IN_A_DAY = 1000 * 60 * 60 * 24;
		const ALLOWED_DAYS_LIMIT = 33;

		const dialogRef = this.matDialog.open(ConfirmationDialogComponent, {
			width: '500px',
			panelClass: 'confirmation-dialog-panel--client',
			data: {
				mode: 'CREATE',
				type: 'custom-fields',
				skipFormValidation: true,
				message: this.translate.instant('BANKRUPTCIES.EXPORT_CONFIRMATION'),
				fields: [
					{
						type: 'date',
						key: 'dateFrom',
						label: 'CLIPS.PUBLICATION_DATE_FROM',
						required: true,
						inline: true
					},
					{
						type: 'date',
						key: 'dateTo',
						label: 'CLIPS.PUBLICATION_DATE_TO',
						required: true,
						inline: true,
						maxDaysFrom: 'dateFrom',
						maxDaysLimit: 33
					}
				]
			},
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result && result.data) {
				const dateFrom = new Date(result.data.dateFrom);
				const dateTo = new Date(result.data.dateTo);

				const diffInDays = Math.abs(dateTo.getTime() - dateFrom.getTime()) / MS_IN_A_DAY;

				if (diffInDays > ALLOWED_DAYS_LIMIT) {
					this.sharedService.showNotification.next({
						message: this.translate.instant('BANKRUPTCIES.EXPORT_DATE_LIMIT_MESSAGE', { ALLOWED_DAYS_LIMIT }),
						type: 'ERROR',
					});
					return;
				}

				const exportRequest: any = {
					clientId: this.client.id,
					dateFrom: dateFrom,
					dateTo: dateTo,
				};

				this.apiLoading = true;
				this.apiClientBankruptcies
					.exportClientBankruptcies(exportRequest)
					.pipe(take(1))
					.subscribe({
						next: (response: any) => {
							const content = new Blob([response as BlobPart], { type: 'application/vnd.ms-excel' });
							const fileURL = URL.createObjectURL(content);
							window.open(fileURL, '_blank');
							this.apiLoading = false;
						},
						error: err => {
							this.sharedService.showNotification.next({
								message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
								type: 'ERROR',
							});
							this.apiLoading = false;
						},
					});
			}
		});
	}

	generateAiSummary() {
		const clippingSubscription = this.client.subscriptions?.find(sub => sub.type === 'CLIPPING');
		const aiSummaryTokens = clippingSubscription?.aiSummaryTokens || 0;
		const aiSummaryEnabled = clippingSubscription?.aiSummary === true;

		if (aiSummaryEnabled) {
			const today = new Date();
			today.setHours(0, 0, 0, 0);
			
			const tokenSeverity = aiSummaryTokens === 0 ? 'low' : aiSummaryTokens <= 5 ? 'medium' : 'high';

			const dialogRef = this.matDialog.open(ConfirmationDialogComponent, {
				width: '500px',
				panelClass: 'confirmation-dialog-panel--client',
				data: {
					mode: 'USER_ACTION',
					type: 'custom-fields',
					message: this.translate.instant('CLIPS.AI_SUMMARY_CONFIRMATION'),
					pillInfo: {
						icon: 'generating_tokens',
						label: 'CLIPS.AVAILABLE_TOKENS',
						value: aiSummaryTokens,
						severity: tokenSeverity,
					},
					confirmDisabled: aiSummaryTokens === 0,
					fields: [
						{
							type: 'date',
							label: this.translate.instant('CLIPS.DATE'),
							required: true,
							data: today,
							maxDate: today
						}
					]
				},
			});

			dialogRef.afterClosed().subscribe(result => {
				if (result && result.data && result.data.dateTime) {
					const selectedDate = new Date(result.data.dateTime);
					selectedDate.setHours(12, 0, 0, 0);
					
					this.apiLoading = true;
					this.apiClippingClips
						.generateClientPdfSummaryReport(selectedDate)
						.pipe(take(1))
						.subscribe({
							next: (response: any) => {
								const content = new Blob([response as BlobPart], { type: 'application/pdf' });
								const fileURL = URL.createObjectURL(content);
								window.open(fileURL, '_blank');
								this.apiLoading = false;
							},
							error: err => {
								const message = err.status === 404
									? this.translate.instant('CLIPS.AI_SUMMARY_NO_CLIPS')
									: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`;

								this.sharedService.showNotification.next({
									message,
									type: 'ERROR',
								});
								this.apiLoading = false;
							},
						});
				}
			});
		} else {
			this.sharedService.showNotification.next({
				message: this.translate.instant('CLIPS.NO_ACCESS_AI_SUMMARY'),
				type: 'WARNING',
			});
		}
	}

	getSentimentRating(sentimentType: 'POSITIVE' | 'NEUTRAL' | 'NEGATIVE', item: ManagementClipResponse, type: 'ICON' | 'CLASS') {
		const score = item.sentiment?.sentimentScore;
		const currentType = score == null ? undefined : score > 0 ? 'POSITIVE' : score < 0 ? 'NEGATIVE' : 'NEUTRAL';
		const active = sentimentType === currentType ? ' active' : '';
		switch (sentimentType) {
			case 'POSITIVE': {
				if (currentType === sentimentType) {
					return type === 'ICON' ? 'sentiment_very_satisfied' : 'positive' + active;
				}
				break;
			}
			case 'NEUTRAL': {
				if (currentType === sentimentType) {
					return type === 'ICON' ? 'sentiment_neutral' : 'neutral' + active;
				}
				break;
			}
			case 'NEGATIVE': {
				if (currentType === sentimentType) {
					return type === 'ICON' ? 'sentiment_very_dissatisfied' : 'negative' + active;
				}
				break;
			}
		}
		return '';
	}

	createUpdateSentimentRating(sentimentType: 'POSITIVE' | 'NEUTRAL' | 'NEGATIVE', item: ManagementClipResponse) {
		const currentScore = item.sentiment?.sentimentScore ?? 0;
		const magnitude = Math.abs(currentScore) || 25;
		let sentimentScore: number;
		if (sentimentType === 'NEUTRAL') {
			if (item.sentiment && currentScore === 0) return;
			sentimentScore = 0;
		} else {
			const desiredSign = sentimentType === 'POSITIVE' ? 1 : -1;
			if (Math.sign(currentScore) === desiredSign) return;
			sentimentScore = magnitude * desiredSign;
		}
		if (item.sentiment && item.sentiment.id) {
			this.apiClientSentiment
				.updateClientSentiment({ sentimentScore }, item.sentiment.id)
				.pipe(take(1))
				.subscribe({
					next: response => {
						this.sharedService.showNotification.next({
							message: this.translate.instant('NOTIFICATIONS.RECORD_UPDATED'),
							type: 'SUCCESS',
						});
						item.sentiment = response;
						this.syncGroupSentimentVisually(item);
					},
				});
		} else if (item.id) {
			this.apiClientSentiment
				.createClientSentiment({ sentimentScore, clipId: item.id, clientId: this.client.id })
				.pipe(take(1))
				.subscribe({
					next: response => {
						this.sharedService.showNotification.next({
							message: this.translate.instant('NOTIFICATIONS.RECORD_UPDATED'),
							type: 'SUCCESS',
						});

						item.sentiment = response;
						this.syncGroupSentimentVisually(item);
					},
				});
		}
	}

	/**
	 * The backend propagates a sentiment set on a MAIN clip to every clip in its group: each
	 * related clip adopts the main's direction (positive/neutral/negative) while keeping its own
	 * magnitude, defaulting to 25 when it had none (see `directedScore` on the backend). Mirror
	 * that same computation in place on the already-loaded related clips so they update instantly,
	 * without a re-fetch or full reload.
	 *
	 * Only main clips propagate, and only an expanded main clip has its related list loaded
	 * (held in `ratedClip.related`); rating a related clip has nothing to sync.
	 */
	private syncGroupSentimentVisually(ratedClip: ManagementClipResponseWithRelated) {
		if (!ratedClip.related) {
			return;
		}

		const sign = Math.sign(ratedClip.sentiment?.sentimentScore ?? 0);
		const current = ratedClip.related as Map<string, any[]>;
		// Rebuild with fresh Map/array/object references so the `@for (... track $index)` in the
		// card re-renders — mutating the existing objects in place isn't picked up reliably.
		const updated = new Map<string, any[]>();
		current.forEach((clips, key) => {
			updated.set(
				key,
				clips.map(clip => {
					const magnitude = Math.abs(clip.sentiment?.sentimentScore ?? 0) || 25;
					const sentimentScore = sign === 0 ? 0 : sign * magnitude;
					return { ...clip, sentiment: { ...(clip.sentiment || {}), sentimentScore } };
				})
			);
		});
		ratedClip.related = updated;
	}
	//** (END) Clipping methods */

	//** Transcription methods */
	actionRequestedTranscription(event: any) {
		switch (event.action) {
			case 'LOAD': {
				this.sharedService.requestActionInComponent.next({
					componentName: 'TranscriptionsFiltersComponent',
					action: 'FILTER_TRIGGER',
				});
				return;
			}
			case 'FILTER': {
				// Keep the header search box in sync with the shared form (e.g. sidebar Reset clears it).
				this.transcriptionSearchText = event.filters?.text ?? '';
				this.filterTranscriptions(event.filters, event.id);
				break;
			}
			case 'UPDATE_SELECTED': {
				this.selectedItems = event.selected;
				break;
			}
			case 'UNSELECT_ALL': {
				this.selectedItems = [];
				(this.itemsList as TranscriptionResponseWithSelection[]).forEach(item => {
					item.checked = false;
				});
				break;
			}
			case 'TAGS_SELECTION_CHANGE': {
				this.sharedService.requestActionInComponent.next({
					componentName: 'TranscriptionsFiltersComponent',
					action: 'FILTER_TRIGGER',
					data: {
						dataAdministrationType: this.dataAdministrationType,
					},
				});
				break;
			}
			case 'CREATE_TRANSCRIPTION': {
				this.openCreateTranscriptionDialog();
				break;
			}
			case 'CREATE_TRANSCRIPTION_FROM_RECORDING': {
				this.createTranscriptionFromRecording(event.audioFile);
				break;
			}
			case 'EDIT_TRANSCRIPTION': {
				this.editTranscription(event.item);
				break;
			}
			case 'EXPORT_TRANSCRIPTION': {
				this.exportTranscription(event.item);
				break;
			}
			case 'TOOLBAR': {
				if (event.groupAction === 'DELETE') {
					this.deleteSelectedTranscriptions();
				}
				break;
			}
			case 'FORM_CLOSED': {
				this.itemForEdit.transcription = null;
				break;
			}
		}

		if (event.groupAction) {
			switch (event.groupAction) {
				case 'SCROLL_TO_TOP': {
					if (this.listScrollAnchor) {
						this.listScrollAnchor.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
						this.scrollToTop.active = false;
					}
					break;
				}
			}
		}
	}

	private filterTranscriptions(filters: ClientTranscriptionFilterRequest, startIndex?: number) {
		this.filtersStore = filters;
		if (this.paginationState('FILTER', startIndex)) {
			this.apiLoading = true;
			const sort = this.listSort === 'newest' ? 'DESC' : 'ASC';
			this.apiClientTranscriptions
				.getClientTranscriptionsPageableFilter(this.filtersStore as ClientTranscriptionFilterRequest, this.pagination.currentPage, this.ITEMS_PER_PAGE, sort)
				.pipe(take(1))
				.subscribe({
					next: response => {
						if (this.appendModeActive) {
							(this.itemsList as any[]).push.apply(this.itemsList, response.content || []);
						} else {
							this.itemsList = response.content || [];
						}
						// CLIPPING-592: totalElements/totalPages only come back on page 0 (the
						// count query is skipped on later pages) - keep the cached value instead
						// of overwriting it with the now-absent fields.
						if (response.totalElements !== undefined && response.totalElements !== null) {
							this.pagination.totalPages = response.totalPages || 0;
							this.pagination.totalElements = response.totalElements;
						}
						this.apiLoading = false;
					},
					error: err => {
						this.sharedService.showNotification.next({
							message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
							type: 'ERROR',
						});
						this.apiLoading = false;
					},
				});
		}
	}

	toggleItemSelection(item: TranscriptionResponseWithSelection) {
		item.checked = !item.checked;

		if (item.checked) {
			if (!this.selectedItems.includes(item)) {
				this.selectedItems.push(item);
			}
		} else {
			const index = this.selectedItems.indexOf(item);
			if (index > -1) {
				this.selectedItems.splice(index, 1);
			}
		}
	}

	private deleteSelectedTranscriptions() {
		if (this.selectedItems.length === 0) return;

		const selectedIds = this.selectedItems.map(item => item.id);
		this.apiLoading = true;

		const deleteRequest: DeleteTranscriptionsRequest = {
			transcriptionIds: selectedIds
		};

		this.apiClientTranscriptions.deleteClientTranscriptions(deleteRequest)
			.pipe(take(1))
			.subscribe({
				next: () => {
					this.apiLoading = false;
					this.sharedService.showNotification.next({
						message: this.translate.instant('NOTIFICATIONS.RECORD_DELETED'),
						type: 'SUCCESS',
					});
					this.selectedItems = [];
					this.actionByTypeSplitter({ action: 'FILTER', filters: this.filtersStore, id: 0 });
				},
				error: error => {
					this.apiLoading = false;
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${error.error?.message || error.message}`,
						type: 'ERROR',
					});
				}
			});
	}
	//** (END) Transcription methods */

	//** Contract Notices methods */
	private actionRequestedContractNotices(event: any) {
		switch (event.action) {
			case 'FILTER': {
				this.filterContractNotices(event.filters, event.id);
				break;
			}
			case 'UPDATE_SELECTED': {
				this.selectedItems = event.selected;
				break;
			}
			case 'TAGS_SELECTION_CHANGE': {
				this.sharedService.requestActionInComponent.next({
					componentName: 'ContractNoticesFiltersComponent',
					action: 'FILTER_TRIGGER',
					data: {
						dataAdministrationType: this.dataAdministrationType,
					},
				});
				break;
			}
			case 'GENERATE_REPORT': {
				// This is called when we need to generate a PDF
				// Check if there's already a PDF file to open, otherwise generate
				if (event.item.fileUrl && this.isPdfFile(event.item.fileUrl)) {
					window.open(event.item.fileUrl, '_blank');
				} else if (event.item.announcementType) {
					this.generateContractAnnouncementPdfReport(event.item.id);
				} else {
					this.generateContractNoticePdfReport(event.item.id);
				}
				break;
			}
			case 'OPEN_LINK': {
				this.openContractNoticeLink(this.utils.suppressType(event.item));
				break;
			}
			case 'RELATED_NOTICES': {
				this.getContractNoticesRelatedContent(event.item);
				break;
			}
		}
	}

	private filterContractNotices(filters: ManagementContractNoticeAndAnnouncementFilterRequest, startIndex?: number) {
		this.filtersStore = filters;

		if (this.paginationState('FILTER', startIndex)) {
			this.apiLoading = true;
			if (this.contractNoticeFilterSubscription$) {
				this.contractNoticeFilterSubscription$.unsubscribe();
			}
			const sort = this.listSort === 'newest' ? 'DESC' : 'ASC';
			this.contractNoticeFilterSubscription$ = this.apiClientContractNotice
				.getClientFilteredContractNoticesAndAnnouncements(
					this.filtersStore as ManagementContractNoticeAndAnnouncementFilterRequest,
					this.pagination.currentPage,
					this.ITEMS_PER_PAGE,
					sort
				)
				.pipe(take(1))
				.subscribe({
					next: response => {
						if (this.appendModeActive) {
							(this.itemsList as ManagementContractNoticeAndAnnouncementResponse[]).push.apply(this.itemsList, response.content || []);
						} else {
							this.itemsList = response.content || [];
						}
						this.pagination.totalPages = response.totalPages || 0;
						this.pagination.totalElements = response.totalElements || 0;
						this.apiLoading = false;
					},
					error: () => {
						this.itemsList = [];
						this.pagination.totalPages = 0;
						this.pagination.totalElements = 0;
						this.apiLoading = false;
					},
				});
		}
	}

	public getContractNoticesRelatedContent(item: ManagementContractNoticeAndAnnouncementWithRelated) {
		if (item.related && item.related.length) {
			item.related = [];
			return;
		}
		item.related = [];

		let contractNoticeId = item.id || '';
		if (item.announcementType) {
			contractNoticeId = item.contractNotice?.id || '';
		}

		this.apiClientContractNotice
			.getRelatedAnnouncements(contractNoticeId)
			.pipe(take(1))
			.subscribe({
				next: response => {
					if (item.announcementType) {
						if (item.contractNotice && !item.contractNotice.createdFromAnnouncement) {
							item.related?.push({ ...item.contractNotice, noticeType: item.contractNotice?.type });
						}
					}
					response.forEach(r => {
						if (r.id !== item.id) {
							item.related?.push({
								...r,
								contractNotice: item.noticeType ? item : item.contractNotice,
								announcementType: r.type,
							});
						}
					});

					if (item.related && item.related.length === 0) {
						this.sharedService.showNotification.next({
							message: this.translate.instant('NOTIFICATIONS.NO_RELATED_CONTENT'),
							type: 'SUCCESS',
						});
					}
				},
			});
	}

	openContractNoticeLink(item: ManagementContractNoticeAndAnnouncementResponse) {
		const url = item.url || (item as any).fileUrl;

		// If no URL exists, generate PDF
		if (!url || url === 'null' || url.trim() === '') {
			this.actionByTypeSplitter({ action: 'GENERATE_REPORT', item: item });
		}
		// If URL is a PDF, open it directly
		else if (this.isPdfFile(url)) {
			window.open(url, '_blank');
		}
		// If URL is an image, generate PDF instead of opening the image
		else if (this.isImageUrl(url)) {
			this.actionByTypeSplitter({ action: 'GENERATE_REPORT', item: item });
		}
		// For other URLs, open them directly
		else {
			window.open(url, '_blank');
		}
	}

	private generateContractNoticePdfReport(id: string) {
		this.apiLoading = true;
		this.apiClientContractNotice
			.generateClientPdfReportForContractNoticeById(id, environment.reseller.name)
			.pipe(take(1))
			.subscribe({
				next: (response: any) => {
					const content = new Blob([response as BlobPart], { type: 'application/pdf' });
					const fileURL = URL.createObjectURL(content);
					window.open(fileURL, '_blank');
					this.apiLoading = false;
				},
				error: (err: any) => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error?.message || err.message}`,
						type: 'ERROR',
					});
					this.apiLoading = false;
				},
			});
	}

	private generateContractAnnouncementPdfReport(id: string) {
		this.apiLoading = true;
		this.apiClientContractAnnouncement
			.generateClientPdfReportForContractAnnouncementById(id, environment.reseller.name)
			.pipe(take(1))
			.subscribe({
				next: (response: any) => {
					const content = new Blob([response as BlobPart], { type: 'application/pdf' });
					const fileURL = URL.createObjectURL(content);
					window.open(fileURL, '_blank');
					this.apiLoading = false;
				},
				error: (err: any) => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error?.message || err.message}`,
						type: 'ERROR',
					});
					this.apiLoading = false;
				},
			});
	}
	//** (END)Contract Notices methods */

	//** Sales methods */
	private actionRequestedSale(event: any) {
		switch (event.action) {
			case 'LOAD': {
				this.sharedService.requestActionInComponent.next({
					componentName: 'SalesFiltersComponent',
					action: 'FILTER_TRIGGER',
				});
				return;
			}
			case 'FILTER': {
				this.filterSales(event.filters, event.id);
				return;
			}
			case 'UPDATE_SELECTED': {
				this.selectedItems = event.selected;
				break;
			}
			case 'GENERATE_REPORT': {
				if (event.item.fileUrl && this.isPdfFile(event.item.fileUrl)) {
					window.open(event.item.fileUrl, '_blank');
				} else if (event.item.publicationUrl) {
					window.open(event.item.publicationUrl, '_blank');
				} else {
					this.generateSalePdfReport(event.item.id);
				}
				break;
			}
		}
	}

	private filterSales(filters: SalesFilterRequest, startIndex?: number) {
		this.filtersStore = filters;
		if (this.paginationState('FILTER', startIndex)) {
			this.apiLoading = true;
			const sort = this.listSort === 'newest' ? 'DESC' : 'ASC';
			this.apiClientSales
				.getClientSalesPageable(this.filtersStore as SalesFilterRequest, this.pagination.currentPage, this.ITEMS_PER_PAGE, sort)
				.pipe(take(1))
				.subscribe({
					next: response => {
						if (this.appendModeActive) {
							(this.itemsList as ManagementSaleResponse[]).push.apply(this.itemsList, response.content || []);
						} else {
							this.itemsList = response.content || [];
						}
						this.pagination.totalPages = response.totalPages || 0;
						this.pagination.totalElements = response.totalElements || 0;
						this.apiLoading = false;
					},
					error: () => {
						this.itemsList = [];
						this.pagination.totalPages = 0;
						this.apiLoading = false;
					},
				});
		}
	}

	private generateSalePdfReport(id: string) {
		this.apiLoading = true;
		this.apiClientSales
			.generateClientPdfReportForSaleById(id)
			.pipe(take(1))
			.subscribe({
				next: (response: any) => {
					const content = new Blob([response as BlobPart], { type: 'application/pdf' });
					const fileURL = URL.createObjectURL(content);
					window.open(fileURL, '_blank');
					this.apiLoading = false;
				},
				error: err => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
						type: 'ERROR',
					});
					this.apiLoading = false;
				},
			});
	}
	//** (END)Sales methods */

	//** Bankruptcies methods */
	private actionRequestedBankruptcy(event: any) {
		switch (event.action) {
			case 'LOAD': {
				this.sharedService.requestActionInComponent.next({
					componentName: 'BankruptciesFiltersComponent',
					action: 'FILTER_TRIGGER',
				});
				return;
			}
			case 'FILTER': {
				this.filterBankruptcies(event.filters, event.id);
				return;
			}
			case 'UPDATE_SELECTED': {
				this.selectedItems = event.selected;
				break;
			}
			case 'GENERATE_REPORT': {
				if (event.item.fileUrl && this.isPdfFile(event.item.fileUrl)) {
					window.open(event.item.fileUrl, '_blank');
				} else {
					this.generateBankruptcyPdfReport(event.item.id);
				}
				break;
			}
		}
	}

	private filterBankruptcies(filters: any, startIndex?: number) {
		this.filtersStore = filters;
		if (this.paginationState('FILTER', startIndex)) {
			this.apiLoading = true;
			const sort = this.listSort === 'newest' ? 'DESC' : 'ASC';
			this.apiClientBankruptcies
				.getClientBankruptciesPageable(this.filtersStore as BankruptciesFilterRequest, this.pagination.currentPage, this.ITEMS_PER_PAGE, sort)
				.pipe(take(1))
				.subscribe({
					next: response => {
						if (this.appendModeActive) {
							(this.itemsList as ManagementBankruptcyResponse[]).push.apply(this.itemsList, response.content || []);
						} else {
							this.itemsList = response.content || [];
						}
						this.pagination.totalPages = response.totalPages || 0;
						this.pagination.totalElements = response.totalElements || 0;
						this.apiLoading = false;
					},
					error: () => {
						this.itemsList = [];
						this.pagination.totalPages = 0;
						this.apiLoading = false;
					},
				});
		}
	}

	private generateBankruptcyPdfReport(id: string) {
		this.apiLoading = true;
		this.apiClientBankruptcies
			.generateClientPdfReportForBankruptcyById(id)
			.pipe(take(1))
			.subscribe({
				next: (response: any) => {
					const content = new Blob([response as BlobPart], { type: 'application/pdf' });
					const fileURL = URL.createObjectURL(content);
					window.open(fileURL, '_blank');
					this.apiLoading = false;
				},
				error: err => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error.message}`,
						type: 'ERROR',
					});
					this.apiLoading = false;
				},
			});
	}
	//** (END) Bankruptcies methods */

	//** Analytics methods */
	private actionRequestedAnalytics(event: any) {
		switch (event.action) {
			case 'LOAD': {
				this.sharedService.requestActionInComponent.next({
					componentName: 'AnalyticsFiltersComponent',
					action: 'FILTER_TRIGGER',
				});
				return;
			}
			case 'FILTER': {
				this.getClipsByDateAnalytics(event.filters);
				this.getClipsByTag(event.filters);
				this.getClipsByMedium(event.filters);
				this.getClipsBySentiment(event.filters);
				this.getClipsByAuthor(event.filters);
				this.getCommonWords(event.filters);
				return;
			}
			case 'UPDATE_SELECTED': {
				this.selectedItems = event.selected;
				break;
			}
			case 'GENERATE_REPORT': {
				if (event.item.publicationUrl) {
					window.open(event.item.publicationUrl, '_blank');
				} else {
					this.generateBankruptcyPdfReport(event.item.id);
				}
				break;
			}
		}
	}

	private getClipsByDateAnalytics(filters: any) {
		this.apiLoading = true;
		const startDate = this.utils.timestampToDateFormatted(filters.startDate);
		const endDate = this.utils.timestampToDateFormatted(filters.endDate);
		this.apiClientAnalytics
			.getClipsByDateAnalytics(startDate, endDate)
			.pipe(take(1))
			.subscribe({
				next: response => {
					this.apiLoading = false;
					this.clipsByDate = response;
				},
				error: () => {
					this.apiLoading = false;
				},
			});
	}

	private getClipsByTag(filters: any) {
		this.apiLoading = true;
		const startDate = this.utils.timestampToDateFormatted(filters.startDate);
		const endDate = this.utils.timestampToDateFormatted(filters.endDate);
		this.apiClientAnalytics
			.getClipsByTagAnalytics(startDate, endDate)
			.pipe(take(1))
			.subscribe({
				next: response => {
					this.apiLoading = false;
					this.clipsByTag = response.map(item => ({
						tagName: item.tagName,
						clipsCount: item.clipsCount,
					}));
				},
				error: () => {
					this.apiLoading = false;
				},
			});
	}

	private getClipsByMedium(filters: any) {
		this.apiLoading = true;
		const startDate = this.utils.timestampToDateFormatted(filters.startDate);
		const endDate = this.utils.timestampToDateFormatted(filters.endDate);
		this.apiClientAnalytics
			.getClipsByMediumAnalytics(startDate, endDate)
			.pipe(take(1))
			.subscribe({
				next: response => {
					this.apiLoading = false;
					this.clipsByMedium = response.map(item => ({
						mediumName: item.mediumName,
						clipsCount: item.clipsCount,
					}));
				},
				error: () => {
					this.apiLoading = false;
				},
			});
	}

	private getClipsBySentiment(filters: any) {
		this.apiLoading = true;
		const startDate = this.utils.timestampToDateFormatted(filters.startDate);
		const endDate = this.utils.timestampToDateFormatted(filters.endDate);
		this.apiClientAnalytics
			.getClipsBySentimentAnalytics(startDate, endDate)
			.pipe(take(1))
			.subscribe({
				next: response => {
					this.apiLoading = false;
					const buckets = { POSITIVE: 0, NEUTRAL: 0, NEGATIVE: 0 };
					response.forEach(item => {
						const score = item.sentimentScore ?? 0;
						const count = item.clipsCount ?? 0;
						if (score > 0) buckets.POSITIVE += count;
						else if (score < 0) buckets.NEGATIVE += count;
						else buckets.NEUTRAL += count;
					});
					this.clipsBySentiment = [
						{ sentimentType: 'POSITIVE', clipsCount: buckets.POSITIVE },
						{ sentimentType: 'NEUTRAL', clipsCount: buckets.NEUTRAL },
						{ sentimentType: 'NEGATIVE', clipsCount: buckets.NEGATIVE },
					];
				},
				error: () => {
					this.apiLoading = false;
				},
			});
	}

	private getClipsByAuthor(filters: any) {
		this.apiLoading = true;
		const startDate = this.utils.timestampToDateFormatted(filters.startDate);
		const endDate = this.utils.timestampToDateFormatted(filters.endDate);
		this.apiClientAnalytics
			.getClipsByAuthorAnalytics(startDate, endDate)
			.pipe(take(1))
			.subscribe({
				next: response => {
					this.apiLoading = false;
					this.clipsByAuthor = response.map(item => ({
						authorName: item.authorName,
						clipsCount: item.clipsCount,
					}));
				},
				error: () => {
					this.apiLoading = false;
				},
			});
	}

	private getCommonWords(filters: any) {
		this.apiLoading = true;
		const startDate = this.utils.timestampToDateFormatted(filters.startDate);
		const endDate = this.utils.timestampToDateFormatted(filters.endDate);
		this.apiClientAnalytics
			.getMostCommonWordsAnalytics(startDate, endDate)
			.pipe(take(1))
			.subscribe({
				next: response => {
					this.apiLoading = false;
					if (response.mostCommonWords && Object.keys(response.mostCommonWords).length > 0) {

            const entries = Object.entries(response.mostCommonWords);
            const sorted = entries.sort((a, b) => b[1] - a[1]);
            const topEntries = sorted.slice(0, 100);
            this.commonWords = topEntries.map(([word, count]) => ({ word, count }));
					}
				},
				error: () => {
					this.apiLoading = false;
				},
			});
	}

	//** (END) Analytics methods */

	//** Transcription methods */
	openCreateTranscriptionDialog() {
		const dialogRef = this.matDialog.open(ConfirmationDialogComponent, {
			width: '500px',
			panelClass: 'confirmation-dialog-panel--client',
			data: {
				mode: 'CREATE',
				type: 'custom-fields',
				fields: [
					{
						type: 'textfield',
						label: 'TRANSCRIPTIONS.TYPES.URL',
						key: 'url'
					},
					{
						type: 'file',
						label: 'TRANSCRIPTIONS.TYPES.FILE',
						key: 'file'
					},
					{
						type: 'selection',
						label: 'TRANSCRIPTIONS.LANG',
						key: 'lang',
						data: [
							{ value: 'MK', name: this.translate.instant('NAVBAR.LANGUAGES.MK'), default: true },
							{ value: 'EN', name: this.translate.instant('NAVBAR.LANGUAGES.EN') },
							{ value: 'AL', name: this.translate.instant('NAVBAR.LANGUAGES.AL') }
						]
					}
				]
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result && result.data) {
				const isFileUpload = !!result.data.file;
				const request = {
					url: isFileUpload ? '' : (result.data.url || ''),
					lang: result.data.lang,
					fileUpload: isFileUpload
				};
				this.createTranscription(request, result.data.file);
			}
		});
	}

	private createTranscription(request: any, file: File | null) {
		this.apiLoading = true;

		if (file && (request.fileUpload || request.recording)) {
			this.uploadFileToB2AndCreateTranscription(request, file);
		} else {
			this.apiClientTranscriptions.createClientTranscription(request)
				.pipe(take(1))
				.subscribe({
					next: () => {
						this.apiLoading = false;
						this.sharedService.showNotification.next({
							message: this.translate.instant('NOTIFICATIONS.RECORD_CREATED'),
							type: 'SUCCESS',
						});
						this.actionByTypeSplitter({ action: 'FILTER', filters: this.filtersStore, id: 0 });
					},
					error: error => {
						this.apiLoading = false;
						this.sharedService.showNotification.next({
							message: `${this.translate.instant('TRANSCRIPTIONS.CREATED_ERROR')} \n ${error.error?.message || error.message}`,
							type: 'ERROR',
						});
					}
				});
		}
	}

	private createTranscriptionFromRecording(audioFile: File) {
		const request = {
			url: '',
			lang: this.translate.currentLang?.toUpperCase() || 'MK',
			fileUpload: false,
			recording: true
		};

		this.createTranscription(request, audioFile);
	}

	private uploadFileToB2AndCreateTranscription(request: any, file: File) {
		const uploadRequest: ResourceRequest = {
			filename: file.name,
			contentType: file.type,
			type: 'TRANSCRIPTION',
			fileSize: file.size
		};

		this.apiTranscriptionUpload.generatePreSignedUrls([uploadRequest])
			.pipe(take(1))
			.subscribe({
				next: response => {
					if (response && response[0]) {
						const uploadUrl = response[0].uploadUrl;
						const cdnUrl = response[0].cdnUrl;

						if (uploadUrl && cdnUrl) {
							this.uploadFileToPresignedUrl(file, uploadUrl, cdnUrl, request);
						} else {
							this.apiLoading = false;
							this.sharedService.showNotification.next({
								message: this.translate.instant('TRANSCRIPTIONS.UPLOAD_ERROR'),
								type: 'ERROR',
							});
						}
					}
				},
				error: error => {
					this.apiLoading = false;
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('TRANSCRIPTIONS.UPLOAD_ERROR')} \n ${error.error?.message || error.message}`,
						type: 'ERROR',
					});
				}
			});
	}

	private uploadFileToPresignedUrl(file: File, uploadUrl: string, cdnUrl: string, transcriptionRequest: any) {
		const reader = new FileReader();
		reader.readAsArrayBuffer(file);
		reader.onload = (event: any) => {
			const content = event.target.result;

			this.http.put(uploadUrl, content, {
				headers: { 'Content-Type': file.type },
				reportProgress: true,
				observe: 'events'
			}).subscribe({
				next: (response: any) => {
					if (response.type === HttpEventType.Response && response.ok) {
						const updatedRequest = {
							...transcriptionRequest,
							url: cdnUrl,
							fileUpload: transcriptionRequest.recording ? false : true
						};

						this.apiClientTranscriptions.createClientTranscription(updatedRequest)
							.pipe(take(1))
							.subscribe({
								next: () => {
									this.apiLoading = false;
									this.sharedService.showNotification.next({
										message: this.translate.instant('NOTIFICATIONS.RECORD_CREATED'),
										type: 'SUCCESS',
									});
									this.actionByTypeSplitter({ action: 'FILTER', filters: this.filtersStore, id: 0 });
								},
								error: error => {
									this.apiLoading = false;
									this.sharedService.showNotification.next({
										message: `${this.translate.instant('TRANSCRIPTIONS.CREATED_ERROR')} \n ${error.error?.message || error.message}`,
										type: 'ERROR',
									});
								}
							});
					}
				},
				error: error => {
					this.apiLoading = false;
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('TRANSCRIPTIONS.UPLOAD_ERROR')} \n ${error.error?.message || error.message}`,
						type: 'ERROR',
					});
				}
			});
		};
	}

	editTranscription(transcription: any) {
		this.itemForEdit.transcription = transcription;
		if (this.inputFormAnchor) {
			this.inputFormAnchor.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	}

	/** Deep-link entry point: fetch a transcription by id and open it in read-only preview. */
	private openTranscriptionPreviewById(id: string) {
		this.apiClientTranscriptions
			.getClientTranscriptionById(id)
			.pipe(take(1))
			.subscribe({
				next: response => {
					this.editTranscription(response);
				},
				error: err => {
					this.sharedService.showNotification.next({
						message: `${this.translate.instant('NOTIFICATIONS.RECORD_ACTION_ERROR')} \n ${err.error?.message ?? ''}`,
						type: 'ERROR',
					});
				},
			});
	}

	exportTranscription(transcription: any) {
		const dialogRef = this.matDialog.open(ConfirmationDialogComponent, {
			width: '400px',
			panelClass: 'confirmation-dialog-panel--client',
			data: {
				type: 'custom-fields',
				mode: 'EXPORT',
				fields: [
					{
						type: 'selection',
						key: 'format',
						label: this.translate.instant('TRANSCRIPTIONS.FORMAT'),
						required: true,
						data: [
							{ value: 'DOCX', label: 'DOCX' },
							{ value: 'TXT', label: 'TXT' },
							{ value: 'SRT', label: 'SRT' }
						]
					},
					{
						type: 'checkbox',
						key: 'mergeText',
						label: this.translate.instant('TRANSCRIPTIONS.MERGE_TEXT'),
						default: false,
						hideWhenSRT: true
					},
					// Speakers are hidden from the client transcription view, so the export option goes with them.
					// {
					// 	type: 'checkbox',
					// 	key: 'includeSpeakers',
					// 	label: this.translate.instant('TRANSCRIPTIONS.INCLUDE_SPEAKERS'),
					// 	default: true,
					// 	hideWhenMergeText: true
					// },
					{
						type: 'checkbox',
						key: 'includeTimestamps',
						label: this.translate.instant('TRANSCRIPTIONS.INCLUDE_TIMESTAMPS'),
						default: true,
						hideWhenMergeText: true,
						hideWhenSRT: true
					}
				]
			},
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result && result.data) {
				const exportRequest: ExportTranscriptionRequest = {
					format: result.data.format,
					mergeText: result.data.mergeText,
					// The option is hidden for clients, so speakers are always left out.
					includeSpeakers: false,
					includeTimestamps: result.data.includeTimestamps
				};

				this.apiLoading = true;
				this.apiClientTranscriptions.exportClientTranscription(exportRequest, transcription.id).subscribe({
					next: (response: any) => {
						this.apiLoading = false;
						this.downloadFile(response, transcription.fileName, result.data.format);
					},
					error: error => {
						this.apiLoading = false;
					}
				});
			}
		});
	}

	private downloadFile(data: any, fileName: string, format: string) {
		const blob = new Blob([data], { type: this.getContentType(format) });
		const url = window.URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.href = url;
		link.download = `${fileName}.${format.toLowerCase()}`;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		window.URL.revokeObjectURL(url);
	}

	private getContentType(format: string): string {
		switch (format) {
			case 'DOCX':
				return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
			case 'TXT':
				return 'text/plain';
			case 'SRT':
				return 'text/plain';
			default:
				return 'application/octet-stream';
		}
	}
	//** (END) Transcription methods */

	//** Helper methods */
	hasTranscriptionContent(item: any): boolean {
		const transcription = item as TranscriptionResponse;
		return !!(transcription?.content && transcription.content.length > 0);
	}

	private isPdfFile(fileUrl: string): boolean {
		if (!fileUrl) {
			return false;
		}

		const lowercaseUrl = fileUrl.toLowerCase();
		return lowercaseUrl.includes('.pdf') || lowercaseUrl.includes('application/pdf') || lowercaseUrl.includes('pdf');
	}

	isImageUrl(fileUrl: string): boolean {
		if (!fileUrl) {
			return false;
		}

		const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];
		const urlLower = fileUrl.toLowerCase();
		return imageExtensions.some(ext => urlLower.includes(ext));
	}
	//** (END) Helper methods */
}
